<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="text-center" style="padding: 50px 0">
          <img alt="IzOnay" :src="imgLogoPath()" />
        </div>

        <form @submit.prevent="getAccount()" :disabled="loading">
          <div class="mb-3">
            <label for="accountCode" class="form-label">Hesap Kodu</label>
            <input
              ref="accountCode"
              type="text"
              v-model="code"
              @input="checkInput('code',$event)"
              class="form-control form-control-lg"
              id="accountCode"
              required
              aria-describedby="accountCodeHelp"
            />
            <!-- <div id="accountCodeHelp" class="form-text">Hesap kodunuzu giriniz.</div> -->
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">E-Posta</label>
            <input
              type="email"
              v-model="email"
              class="form-control form-control-lg"
              id="email"
              required
            />
          </div>
          <div class="d-grid gap-2">
            <input type="submit" class="btn btn-primary btn-lg" value="Devam" />
          </div>
        </form>

        <div v-show="isExternalLoginAvailable" class="row m-5" id="external-logins">
            <div class="col-md-12">   
                <div class="text-center">             
                    <h6>Veya şununla oturum açın:</h6>
                </div>
            </div>
            <div v-if="isADFSLoginEnabled" class="col">
                <LoginWithADFS></LoginWithADFS>
            </div>
            <div v-else class="col">
                <LoginWithMicrosoft></LoginWithMicrosoft>
            </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import LoginWithMicrosoft from '@/components/Login/LoginWithMicrosoft.vue'
import LoginWithADFS from '@/components/Login/LoginWithADFS.vue'

export default {
  data() {
    return {
      loading: false,
      code: window.settings.defaultAccountCode ?? "",
      email: ""
    };
  },
    components:{
        LoginWithMicrosoft,
        LoginWithADFS
    },
  computed: {
        isADFSLoginEnabled(){
            return window.settings.authentication?.adfs?.enabled;
        },
        isAzureLoginEnabled(){
            return window.settings.authentication?.adfs?.enableAzure;
        },
        isExternalLoginAvailable()
        {
            if(!this.isOnPrem || this.isADFSLoginEnabled  || this.isAzureLoginEnabled)
                return true;
            
            return false;
        }
  },
  methods: {
    imgLogoPath() {
      try {
        return window.settings.customization.imgLogo == null ? require("../assets/logo.png") : "../img/" + window.settings.customization.imgLogo;
      } catch (e) {
        return require("../assets/logo.png");
      }
      
    },
    getAccount() {
      if (!this.code) {
        this.$refs.accountCode.focus();
        return;
      }

      this.loading = true;
      axios
        .get("/onpremaccount/get?code=" + this.code)
        .then(x => {
          console.log(x);
          console.log(location)
          let questionMarkIndex = location.href.indexOf('?');
          let newSubstring = `#${this.code}&${this.email}`;
          var url = ""
          if(questionMarkIndex != -1)
            url = "login/" + location.href.slice(questionMarkIndex) + newSubstring
          else
            url = "login/" + newSubstring
          
          if (x.data) {
            location.href = x.data.MobileAppUrl + "&" + this.email;
          } else {
            this.$router.push(url);
          }
        })
        .catch(() => {
          this.$izonayAlert("İşlem gerçekleştirilemedi.");
          this.loading = false;
        });
    },
    handleCodeInput(){
      //console.log(this.code)
      const turkishChars = {
        'Ç': 'C', 'ç': 'c',
        'Ğ': 'G', 'ğ': 'g',
        'İ': 'I', 'ı': 'i',
        'Ö': 'O', 'ö': 'o',
        'Ş': 'S', 'ş': 's',
        'Ü': 'U', 'ü': 'u',
        'I': 'i'  // Special case: Convert capital 'I' to lowercase 'i'
    };

    var data =  this.code.replace(/[\u00C7\u00E7\u011E\u011F\u0130\u0131\u00D6\u00F6\u015E\u015F\u00DC\u00FCI]/g, function(match) {
        return turkishChars[match] || match;
    }).toLowerCase();  // Convert to lowercase
      //var data =  this.code.replace(/I/g, 'i').toLocaleLowerCase('tr')
      this.code = data;
  },
  checkInput() {
      this.handleCodeInput()
      if (/[<>]/.test(this.code)) {
          alert('< ve > sembolleri kabul edilmemektedir.');
          this.code = ""; 
      }
    },
  }
};
</script>
